import { getHttpApi } from '@cian/http-api/browser';
import { fetchGetRegion, TGetRegionResponse } from '../../../../shared/repositories/monolith-python/v1/get-region';
import { getConfig } from '@cian/config/browser';

export const getRegion = (regionId: number): Promise<TGetRegionResponse> =>
  fetchGetRegion({
    httpApi: getHttpApi(),
    parameters: {
      regionId,
    },
    config: { subdomain: getConfig().getStrict<string>('subdomain') },
  });
